import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-6 h-6" }
const _hoisted_2 = {
  class: "animate-spin h-full w-full",
  style: {"animation-duration":"0.2s"},
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-from-class": "opacity-0 transform scale-0",
    "enter-active-class": "transition",
    "leave-to-class": "opacity-0 transform scale-0",
    "leave-active-class": "transition",
    appear: "",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }, null, -1 /* HOISTED */),
          _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }, null, -1 /* HOISTED */)
        ])))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}